import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useSelector } from 'react-redux';
import { ComparePopupContainer } from '../../../containers/ComparePopupContainer';
import { makeGetProductState } from '../../../redux/product/selectors/ProductSelector';
export const ComparePopupAlpha = ({ isStickyBar }) => {
    const productState = useSelector(makeGetProductState());
    const { feature_toggles: { product_compare }, } = useAemConfig();
    const showPopup = product_compare &&
        ((productState.available && !productState.outOfStock && !productState.selectedColorOutOfstock) ||
            (productState.available && productState.outOfStock));
    return showPopup ? _jsx(ComparePopupContainer, { isStickyBar: isStickyBar }) : null;
};
